import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleItem = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            Find answers to the most common questions about VigorBuy Spreadsheet resources, safety, and how to get
            started.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleItem(idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <div
                  className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    openIndex === idx ? 'bg-primary-500 text-white rotate-180' : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-6 pb-5 text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}